export default __webpack_public_path__ + "static/media/DNo.20-1.7c8530df.jpg";